export const code_state_type = [
  {
    id: 3,
    code: "End",
    description: "End",
  },
  {
    id: 2,
    code: "step",
    description: "Step",
  },
  {
    id: 1,
    code: "Start",
    description: "Start",
  },
];
